import { LitElement } from "lit";
import { customElement, query } from "lit/decorators.js";

@customElement("bible-book-explore-section")
export class ExploreSectionElement extends LitElement {
  @query(".BibleBookExplore__section_title > button")
  private $button?: HTMLButtonElement;

  @query(".BibleBookExplore__section_title > img")
  private $img?: HTMLImageElement;

  createRenderRoot() {
    return this;
  }

  disconnectedCallback() {
    this.$button?.removeEventListener("click", this);
    this.$img?.removeEventListener("click", this);
  }

  firstUpdated() {
    this.$button?.addEventListener("click", this);
    this.$img?.addEventListener("click", this);
  }

  handleEvent() {
    const $button = this.$button;
    const expanded = $button?.getAttribute("aria-expanded") === "true";
    $button?.setAttribute("aria-expanded", !expanded ? "true" : "false");
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-book-explore-section": ExploreSectionElement;
  }
}
